export default "__VITE_ASSET__DtNSNQwM__"